import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import Icon from "./Icon";
import PropTypes from "prop-types";

class PaginatedItems extends Component {
  constructor({ itemsPerPage, items }) {
    super();
    this.state = {
      currentItems: items.slice(0, itemsPerPage),
      pageCount: Math.ceil(items.length / itemsPerPage),
    };
  }

  handlePageClick = (event) => {
    const { itemsPerPage, items } = this.props;
    const startOffset = (event.selected * itemsPerPage) % items.length;
    const endOffset = startOffset + itemsPerPage;
    this.setState({
      currentItems: items.slice(startOffset, endOffset),
      pageCount: Math.ceil(items.length / itemsPerPage),
    });
    window.scrollTo(0, 0);
  };

  render() {
    const { children } = this.props;

    return (
      <React.Fragment>
        {children(this.state.currentItems)}
        <ReactPaginate
          nextLabel={
            <Icon
              iconName="chevron-right"
              className="icon--chevron-big"
              viewBox="0 0 7 11"
            />
          }
          previousLabel={
            <Icon
              iconName="chevron-left"
              className="icon--chevron-big"
              viewBox="0 0 7 11"
            />
          }
          onPageChange={this.handlePageClick}
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          pageCount={this.state.pageCount}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          nextClassName=""
          previousClassName=""
          pageClassName=""
          breakClassName=""
          activeClassName=""
          nextLinkClassName="pagination__next"
          previousLinkClassName="pagination__previous"
          pageLinkClassName="pagination__list"
          breakLinkClassName="pagination__list"
          disabledClassName="pagination__disabled"
          activeLinkClassName="pagination__active"
          breakLabel="..."
        />
      </React.Fragment>
    );
  }
}

PaginatedItems.propTypes = {
  children: PropTypes.element.isRequired,
};

export default PaginatedItems;



// WEBPACK FOOTER //
// ./src/components/Common/PaginatedItems.js